/** Layouts */
import BaseLayout from '@/views/gpao/of/layouts/BaseLayout';
import EditLayout from '@/views/gpao/of/layouts/EditLayout';
import ShowLayout from '@/views/gpao/of/layouts/ShowLayout';

/** Components */
import List from '@/views/gpao/of/components/List';
import Create from '@/views/gpao/of/components/Create';
import Edit from '@/views/gpao/of/components/Edit';
import Show from '@/views/gpao/of/components/Show';
import Document from '@/views/fichier/pages/Fichier';

import ConsommationList from '@/views/gpao/of/components/consommation/List';
import ConsommationCreate from '@/views/gpao/of/components/consommation/Create';

import ProductionList from '@/views/gpao/of/components/production/List';
import ProductionCreate from '@/views/gpao/of/components/production/Create';

import OperateurList from '@/views/gpao/of/components/operateur/List';
import OperateurCreate from '@/views/gpao/of/components/operateur/Create';

import ReportingOF from '@/views/gpao/of/components/reporting/Reporting';

export default [
  {
    path: '/gpao/of',
    component: BaseLayout,
    children: [
      {
        path: '',
        component: List,
        name: 'gpao_of',
        meta: {
          auth: true,
          module: 'gpao',
          permission: 'access setting',
        },
      },
      {
        path: 'create',
        component: Create,
        name: 'gpao_of-create',
        meta: {
          auth: true,
          module: 'gpao',
          permission: 'access setting',
        },
      },
      {
        path: 'edit/:id',
        component: EditLayout,
        children: [
          {
            path: '',
            component: Edit,
            name: 'gpao_of-edit',
            meta: {
              auth: true,
              module: 'gpao',
              permission: 'access setting',
            },
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'gpao_of_edit-document',
            meta: {
              auth: true,
              module: 'gpao',
              permission: 'access setting',
            },
          },
          {
            path: 'consommation',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ConsommationList,
                name: 'gpao_of_edit_consommation',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: ConsommationCreate,
                name: 'gpao_of_edit_consommation-create',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'production',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ProductionList,
                name: 'gpao_of_edit_production',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: ProductionCreate,
                name: 'gpao_of_edit_production-create',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'operateur',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: OperateurList,
                name: 'gpao_of_edit_operateur',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: OperateurCreate,
                name: 'gpao_of_edit_operateur-create',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'reporting',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ReportingOF,
                name: 'gpao_of_edit_reporting',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'show/:id',
        component: ShowLayout,
        children: [
          {
            path: '',
            component: Show,
            name: 'gpao_of-show',
            meta: {
              auth: true,
              module: 'gpao',
              permission: 'access setting',
            },
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'gpao_of_show-document',
            meta: {
              auth: true,
              module: 'gpao',
              permission: 'access setting',
            },
          },
          {
            path: 'consommation',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ConsommationList,
                name: 'gpao_of_show_consommation',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: ConsommationCreate,
                name: 'gpao_of_show_consommation-create',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'production',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ProductionList,
                name: 'gpao_of_show_production',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: ProductionCreate,
                name: 'gpao_of_show_production-create',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'operateur',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: OperateurList,
                name: 'gpao_of_show_operateur',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
              {
                path: 'create',
                component: OperateurCreate,
                name: 'gpao_of_show_operateur-create',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
          {
            path: 'reporting',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: ReportingOF,
                name: 'gpao_of_show_reporting',
                meta: {
                  auth: true,
                  module: 'gpao',
                  permission: 'access setting',
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
